(function() {
    'use strict';
    /**
     Enhances an element to show an alert. See Odigeo wiki ONEFRONT/Forms UX documentation on Form alert messages

     <div class="od-alert od-alert-warning filters_no_direct_flights">
        <div class="od-alert-container">
            <span class="od-alert-icon ficon">s</span>
            <span class="od-alert-content">No direct results found, now showing results with stops.</span>
            <span class="od-alert-close ficon alert_close">r</span>
         </div>
     </div>
     *
     * @param {jquery} wrapper
     * @param {object} opts
     * @return {jquery}
     */
    Odigeo.UIElements.enhanceAlert = function(wrapper, opts) {
        var $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        var defaults = {
            close: true,
            visible: false,
        };
        var options = Odigeo._.extend(defaults, opts);
        var $alertMessageType;
        var $alertMessageContainer;

        if ($wrapper.attr('data-skip-enhance') === 'true') {
            return $wrapper;
        }

        $wrapper.attr({'data-skip-enhance': true});

        $alertMessageContainer = $('<div>', {'class': 'od-alert-container'});

        if (options.icon) {
            $alertMessageContainer.append($('<span>', {'class': 'od-alert-container-icon ficon'}).append(options.icon));
        }
        $alertMessageContainer.append($('<span>', {'class': 'od-alert-container-content'}).append(options.message));

        if (options.close) {
            $alertMessageContainer.append($('<span>', {'class': 'od-alert-container-close alert_close ficon'}).append('r'));
        }

        $alertMessageType = $('<div>', {'class': 'od-alert od-alert-' + options.type + ' alert_selector'});
        $alertMessageType.append($alertMessageContainer);

        $wrapper.append($alertMessageType);

        var _show = function(evt, delay) {
            Odigeo._.delay(function() {
                $wrapper.find('.alert_selector').addClass('show');
            }, delay || 0);
        };

        var _hide = function() {
            $wrapper.find('.alert_selector').removeClass('show');
        };

        var _delete = function() {
            $wrapper.removeAttr('data-skip-enhance').html('');
        };

        if (options.visible === true) {
            _show();
        } else {
            _hide();
        }

        $wrapper
            .off()
            .on('showMessage', Odigeo._.bind(_show, this))
            .on('hideMessage', Odigeo._.bind(_hide, this))
            .on('deleteMessage', Odigeo._.bind(_delete, this))
            .on(Odigeo.Events.tap, '.alert_close', Odigeo._.bind(_hide, this));

        return $wrapper;
    };
}());
